<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex">
            <section class="mu-d-flex">
                <h1 class="mu-mb-00">Form details</h1>
                <details class="mcc-popover mcc-popover--bottom-end">
                    <summary class="mcc-button mcc-button--icon-only ">
                        <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                    </summary>
                    <div class="mcc-popover__content">

                        <p class="mu-mb-00">
                            {{ (copyForm)? helpTextCopy.title : helpText.title }}
                            <a :href="helpText.url" target="_blank">Read more...</a>
                        </p>
                    </div>
                </details>
            </section>
            <div>
            </div>
        </div>
    </div>
    <div class="mcc-container card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Design</li>
                <li>
                    <a class="table-link" href="#" @click="redirectToApplicationList()">Applications</a>
                </li>
                <li>
                    <a class="table-link" href="#" @click="$router.push(CONTEXT_PATH + '/design/applications/' + applicationId)">{{applicationName}}</a>
                </li>
                <li>Create new</li>

            </ol>
        </nav>
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>
        <div class="mcc-card">
            <div class="mcc-card__body">
                <div class="mcc-row" v-if="fetchCall">
                    <div class="mcc-col mcc-col-md-12 mcc-col-sm-12 mcc-col-xs-12">
                        <form @submit.prevent="saveForm()" id="formId" novalidate>

                            <div style="position:relative">
                                <div v-if="!updateCall" class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>
                                <div class="mcc-card">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Details</h2>
                                    </div>
                                    <div class="mcc-card__body">
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05 mfc-form-input-wrapper--width">
                                            <label for="form-key" class="mfc-label--required">Form key</label>
                                            <input type="text" id="form-key" name="form-key" required="true" maxlength="50" placeholder="Form key" ref="key" :value="applicationForm.key" :pattern="formKeyRegex" @change="updateKey($event)">
                                            <div class="mfc-help-text">
                                                <span>Form key cannot be changed once form is created.</span>
                                            </div>
                                        </div>
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05 mfc-form-input-wrapper--width">
                                            <label for="name" class="mfc-label--required">Name</label>
                                            <input type="text" id="name" maxlength="50" name="name" required="true" placeholder="Name" :value="applicationForm.name" ref="name" :pattern="nameRegex" @change="updateName($event)">
                                        </div>
                                        <div class="mfc-textarea-wrapper mfc-form-input-container mu-mb-05  mfc-form-input-wrapper--width">
                                            <label for="description" class="mu-mb-00">Description</label>
                                            <textarea id="description" name="description" ref="description" maxlength="100"  placeholder="Description" :pattern="descRegex" :value="applicationForm.description" @change="updateDescription($event)" @input="applicationForm.description = $event.target.value" character-count=""></textarea>
                                            <div class="mfc-invalid-feedback"></div>
                                            <div class="mfc-help-text mu-mt-00">
                                                <span>You have {{100 - applicationForm.description.length}} characters remaining</span>
                                            </div>
                                        </div>
                                        <div class=" mfc-form-input-wrapper--width">
                                            <TagInput :labels="labelsNew" ref="labels"></TagInput>
                                        </div>
                                        <div class="mfc-checkbox-wrapper my-2 mfc-form-input-container" v-if="copyForm" id="copyJson" ref="copyJson" name="copyJson" :checked="applicationForm.copyJson" @change="applicationForm.copyJson = $event.target.checked" color="primary">
                                            <input type="checkbox" id="copyJsonForm" class="mfc-switch">
                                            <label for="copyJsonForm">Copy form</label>

                                        </div>
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <div class="mu-d-flex mu-justify-content-end mu-mt-03 ">
                                                    <div class="mcc-button-group mcc-button-group--spaced">
                                                    <button class="mcc-button mcc-button--outline" id="cancelBtn" @click="handleCancelBtn()" title="Cancel" type="button">
                                                        <mcc-icon class="mcc-icon" name="cancel" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Cancel</span>
                                                    </button>
                                                    <button class="mcc-button mcc-button--success" title="Save" id="saveBtn" type="submit">
                                                        <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                                    </button>
                                                </div>
                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </form>

                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import ApplicationFormAPI from "../../../services/ApplicationFormAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import TagInput from "../../common/TagInput.vue";
import {
    handleFormValidation,
    validationMessages, displayErrorMessage, checkFormAndTextareaValidations
} from '../../../formvalid.js';

export default {
    name: "ApplicationFormCreate",
    data() {
        return {
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            formKeyRegex: constantMessages.PATTERNS["nameWithoutSpaces"],
            applicationForm: {
                description: ""
            },
            applicationId: this.$route.params.appId,
            applicationName: "",
            applicationInfo: {}.name,
            helpText: constantMessages.BREADCRUMB_HELP["application.form.create"],
            helpTextCopy: constantMessages.BREADCRUMB_HELP["application.form.copy"],
            showHelpText: false,
            copyForm: false,
            labelsNew: [],
            updateCall: true,
            fetchCall: false,
            isDescriptionValid: true
        };
    },
    components: {
        TagInput
    },
    created() {},
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        ApplicationFormAPI.getApplicationInfo(self.applicationId)
            .then(result => {
                if (result.formApplication == null) {
                    self.$router.push(
                        self.CONTEXT_PATH + "/design/applications"
                    );
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching application"
                    });
                    return;
                }
                if (result.formApplication != null) {
                    self.applicationInfo = result.formApplication;
                    self.applicationName = result.formApplication.name;

                    let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.design.forms.create"];
                    EventBus.$emit("update-pageTitle", pageTitle);
                    return;
                }
            })
            .finally(() => {});

        if (this.$route.query.copyFormId) {
            this.copyForm = true;
            ApplicationFormAPI.copyForm(
                self.applicationId,
                this.$route.query.copyFormId
            ).then(response => {
                if (response.data != null && response.data.copyForm == true) {
                    self.applicationForm = response.data.applicationForm;
                    if (self.applicationForm.labels != null && self.applicationForm.labels != "") {
                        let labelsArray = self.applicationForm.labels.split(",");
                        labelsArray.forEach(element => {
                            self.labelsNew.push(element);
                        });
                    }
                }
            }).finally(() => {
                self.fetchCall = true;
            });
        } else {
            self.fetchCall = true;
        }
    },
    methods: {
        saveForm() {
            let self = this;
            let form = $('#formId')
            if(!self.isDescriptionValid){
                return;
            }
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }      
            
            self.applicationForm.labels = this.$refs.labels.value;
            self.updateCall = false;
            ApplicationFormAPI.saveForm(
                this.applicationForm,
                this.applicationId
            ).then(response => {
                self.updateCall = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        } else if (k == "key") {
                            self.$refs.key.classList.add("ms-is-invalid")
                            displayErrorMessage($(self.$refs.key), constantMessages.MESSAGES[response.messages[k]])
                        } else if (k == "labels") {
                            displayErrorMessage($('#tags'), constantMessages.MESSAGES[response.messages[k]])
                            $('#tags')[0].classList.add('ms-is-invalid')
                            $('.mfc-tags-input')[0].classList.add('ms-is-invalid')
                        } else {
                            EventBus.$emit('error-notification', {
                                "msg": constantMessages.MESSAGES[response.messages[k]]
                            });
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES["message.form.add"]
                    });
                    this.$router
                        .push(
                            this.CONTEXT_PATH +
                            "/design/applications/" +
                            this.applicationId +
                            "/appforms/" +
                            response.data.id
                        )
                        .catch(err => {});
                }
            });
        },
        updateDescription(event) {
            let self = this;
            if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.length"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.description.invalid"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isDescriptionValid = true;
            }
            self.applicationForm.description = event.target.value;
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }

            self.applicationForm.name = event.target.value;
        },
        updateKey(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.key), constantMessages.MESSAGES["error.key.required"])
                self.$refs.key.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.key), constantMessages.MESSAGES["error.key.length"])
                self.$refs.key.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.key), constantMessages.MESSAGES["error.key.invalid"])
                self.$refs.key.classList.add("ms-is-invalid")
            } else {
                self.$refs.key.classList.remove("ms-is-invalid")
            }
            self.applicationForm.key = event.target.value;
        },
        redirectToApplicationList() {
            localStorage.setItem("application", "application");

            this.$router.push(
                this.CONTEXT_PATH + '/design/applications'
            );
        },
        handleCancelBtn() {
            let self = this;
            if (!self.copyForm) {
                self.$router.push(
                    self.CONTEXT_PATH + '/design/applications/' + self.applicationId
                );
                return;
            } else {
                self.$router.push(
                    self.CONTEXT_PATH +
                    "/design/applications/" +
                    self.applicationId +
                    "/appforms/" +
                    self.$route.query.copyFormId
                );
            }
        },

    }
};
</script>

<style>
.mc-forms__valid-feedback {
    display: none;
}

.mc-forms__invalid-feedback {
    display: none;
}
</style>
